module.exports = __webpack_public_path__ + "static/media/pt-aigfutura-lightitalic-webfont.4980588d.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/pt-aigfutura-lightitalic-webfont.woff
// module id = 368
// module chunks = 3